import Tools from '../../tools/Tools';
export default class Step4{
	constructor(view,lang){
		console.log('Step4 :: init',view);

		this.view 		= view;
		this.lang 		= lang;
		this.firstLoad	= true;
	}

	load(location, option, firstDay, extension, formPackage, isOka){
		console.log('Step 4 :: Load :: ', location + ", " + option + ", " + isOka);

		if(!this.firstLoad) $('#calendar').fullCalendar('destroy');

		this.firstLoad = false;

		$('#calendar').fullCalendar({
			header: {
			    left: '',
			    center: 'prev,title,next',
			    right: 'today'
			},
			showNonCurrentDates: false,
			events: {
				url: 'wp-admin/admin-ajax.php',
				type: 'GET',
				data : {
					action : 'calendar',
					location : location,
					option : option,
					extension: extension,
					package: formPackage
				}
			},
			loading : function( isLoading, view ){
				if(isLoading) document.querySelector('.container').classList.add('load');
				else document.querySelector('.container').classList.remove('load');
			},
			eventAfterAllRender: function(view) {
			    if(isOka) document.querySelector('#calendar .fc-view-container').classList.add('isOka');
				else document.querySelector('#calendar .fc-view-container').classList.remove('isOka');
			},
			firstDay:1,
			defaultDate:firstDay,
			locale: this.lang+'-ca',
			columnHeaderFormat: 'dddd',
			aspectRatio: 1.065,
			eventClick: this.onClickEvent.bind(this)
		});


		Tools.scrollTo(0,$(document.querySelector('section.reservation .container')).offset().top - 40);

	}

	onClickEvent(calEvent, jsEvent, view){}

}